/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_TitleInputs */



/**
* | output |
* | --- |
* | "Merge Event" |
*
* @param {Merge_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_title = /** @type {((inputs?: Merge_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner l'Evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführungsereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Событие слияния")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento de fusión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マージイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विलय कार्यक्रम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento de Fusão")
	return /** @type {LocalizedString} */ ("Merge Event")
});